module.exports = __webpack_public_path__ + "img/all-events-blue.ddfc0570.svg";